<template>
	<div style="background-color:#fffcf7;" class="container">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="1"
		/>
		<div
			class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center"
			data-aos="flip-up"
			data-aos-easing="ease-out-cubic"
			data-aos-duration="2000"
			style="
			display: flex;
			align-items: center;
			justify-content: center;
			align-content: center;
			"
		>
			<div style="width: 75%; max-width: 500px;">
				<!-- <h2 class="text-center bMikhak">
					asdasdasd
				</h2> -->
				<textInput
					type="text"
					:val="val.fullName"
					:disabled="true"
					placeholder="نام و نام خانوادگی"
					label="نام و نام خانوادگی"
					@inputTxtFunc="(e)=>{ val.fullName = e }"
				/>
				<textInput
					type="text"
					:val="val.sex == 1 ? 'مرد' : 'زن' "
					:disabled="true"
					placeholder="جنسیت"
					label="جنسیت"
					@inputTxtFunc="(e)=>{ val.sex = e }"
				/>
				<textInput
					type="text"
					:val="val.fatherName"
					:disabled="true"
					placeholder="نام پدر"
					label="نام پدر"
					@inputTxtFunc="(e)=>{ val.fatherName = e }"
				/>
				<textInput
					type="text"
					:disabled="true"
					:val="val.identityId"
					placeholder="شماره شناسنامه"
					label="شماره شناسنامه"
					@inputTxtFunc="(e)=>{ val.identityId = e }"
				/>
				<!-- {{ val }} -->
				<div class="d-flex w-100 align-items-center justify-content-center mb-4 mt-4">
					<span>آیا اطلاعات فوق را تایید می کنید؟</span>
				</div>
				<div class="d-flex w-100 align-items-center justify-content-center">
					<btn
						@clickMe="showOverlay()"
						class="w-50 mt-3 mx-2"
						textClass="w-100"
						text="خیر"
						type="outline-success"
					/>
					<btn
						@clickMe="sav()"
						class="w-50 mt-3 mx-2"
						textClass="w-100"
						text="بله"
					/>
				</div>
			</div>
		</div>
		<div id="overlay" v-on:click="exit(1)" class="position-fixed d-flex vw-100 vh-100 align-items-center justify-content-center overlay">
			<div @clickMe="exit(1)" class="position-absolute w-100 h-100 close"></div>
			<div class="position-relative w-50 h-50 d-flex  align-items-center justify-content-center flex-column bg-white box">
				<img
					height="35px;"
					:src="img.Logo_Header"
					alt="ایزی تیک"
					title="ایزی تیک"
				/>
				<div class="mb-2 mt-4"><span> لطفا برای دسترسی به پنل خودتان </span></div>
				<div class=""><span>با شماره های پشتیبانی ایزی تیک 88625168-021 و 88618512-021 تماس بگیرید.</span></div>
				<div class="d-flex align-items-center justify-content-center bg-white whatsapp mt-3">
					<div class="d-flex align-items-center justify-content-center box">
						<img
							:src="img.Whatsapp_white"
							width="16"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import textInput from  "../../UI/input/textInput.vue";
	import inputcalender from  "../../UI/calendar/inputcalender.vue";
	import calendar from  "../../UI/calendar/calendar.vue";
	import btn from  "../../UI/button/btn.vue";
	import { validatePhone, indexFinder } from  "../../assets/library/filter.js";
	import { textRule } from  "../../assets/text/rule.js";
	import { error } from  "../../assets/library/messege.js";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import Logo_Header from '../../assets/img/Logo_Header.svg';
	import Whatsapp_white from '../../assets/img/whatsapp_white.svg';

	export default {
			name: 'teachers_id',
		data(){
			return {
				error: error,
				validatePhone: validatePhone,
				indexFinder: indexFinder,
				textRule: textRule,
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				val:{
					"page": 0,
					"mobile": "",
				},
				img: {
					"Logo_Header": Logo_Header,
					"Whatsapp_white": Whatsapp_white,
				}

			}
		},
		components: {
			btn,
			textInput,
			inputcalender,
			calendar,
			multi_step_progress,
		},
			props: ["val"],
		mounted(){
			this.$swal.close();
		},
		methods:{
			exit: function (mod="1") {
				this.$localStorage.remove('user');
				var rtr = (mod=="1") ? "/" : "/";
				this.$router.push(rtr);
				document.getElementById("overlay").setAttribute("style","visibility:hidden;opacity:0;");
			},

			showOverlay(THIS=this){
				if(this.val.mobile==""){
					THIS.error(THIS, 'اطلاعات را تکمیل نمایید');
				} else if(!this.validatePhone(this.val.mobile)) {
					THIS.error(THIS, 'شماره موبایل اشتباه است');
				} else {
					window.$.post(THIS.baseurl + "ithub/blockteacher", { 
						token: this.$localStorage.get("user"), 
						phone: THIS.val.mobile, 
						nId: THIS.val.nId, 
					}, function(D){
						if(D.data == true) {
							document.getElementById("overlay").setAttribute("style","visibility:visible;opacity:1;");
							// THIS.error(THIS, 'دسترسی شما محدود شد.! با ئشتیبان سایت تماس بگیرید!')
						} else {
							THIS.error(THIS, D.data)
						}
					}, "json");
				}
			},

			showRule(THIS = this){
				var index_text = this.indexFinder(this.$localStorage.get('settings'), "3");
				THIS.$swal.fire({
					position: 'center',
					type: '',
					html: "<p class='text-justify'>" + this.$localStorage.get('settings')[index_text].dsc + "</p>" ,
					width: '80%',
					title: this.$localStorage.get('settings')[index_text].title,
					showCloseButton: true,
					showConfirmButton: true,
					confirmButtonText: "بستن",
				});
			},
			// *********************************************************************
			chechRole(){
				let user = this.$localStorage.get('user');
				if(user == null){
					return true;
				}else if(user.username.role != 3){
					return true;
				}else{
					return false;
				}
			},
			// *********************************************************************
			sav(THIS=this){
				if(this.val.mobile==""){
					THIS.error(THIS, 'اطلاعات را تکمیل نمایید');
				} else if(!this.validatePhone(this.val.mobile)) {
					THIS.error(THIS, 'شماره موبایل اشتباه است');
				} else {
					window.$.post(THIS.baseurl + "ithub/saveteacher", { 
						token: this.$localStorage.get("user"), 
						phone: THIS.val.mobile, 
						nId: THIS.val.nId, 
						bDate: THIS.val.date, 
						identityId: THIS.val.identityId, 
						email: THIS.val.email,
						fatherName: THIS.val.fatherName,
						fullName: THIS.val.fullName,
						sex: THIS.val.sex,
					}, function(D){
						if(D.data.customMessage) {
							THIS.error(THIS, D.data.customMessage)
							document.getElementById("overlay").setAttribute("style","visibility:visible;opacity:1");
						} else if(!D.data) {
							THIS.error(THIS, 'کد ملی اشتباه است.! لطفا کد ملی صحیح را وارد نمایید.')
							document.getElementById("overlay").setAttribute("style","visibility:visible;opacity:1");
						} else if(D.data == true) {
							// THIS.error(THIS, 'اطلاعات شما با موفقیت ثبت شد. شما به ادامه فرآیند هدایت می شوید.')
							THIS.val.page = 4;
							THIS.$emit('next_page', THIS.val);
						} else {
							THIS.error(THIS, D.data)
						}
					}, "json");
				}
			},
			// *********************************************************************
		}
	}
</script>

<style>
.overlay {
	/* display: none !important; */
	visibility: hidden;
	opacity: 0;
	top: 0;
	right: 0;
	z-index: 2020;
}
.overlay .close {
	top: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.4);
	cursor: pointer;
	z-index: 2021;
}
.overlay .close:hover, .overlay .close:not(:disabled):not(.disabled):focus {
    opacity: .5 !important;
 
}
.overlay .box {
	border-radius: 15px;
	box-shadow: 0 0.5rem 0.5rem rgb(0 0 0 / 10%);
	z-index: 2022;
}
.overlay .box .whatsapp {
	width: 252px;
	height: 55px;
	border-radius: 20px 20px 20px 0;
}

.overlay .box .whatsapp .box {
	width: 247px;
	height: 50px;
	background-color: #42c553;
	border-radius: 20px 20px 20px 0;
}
.overlay .box .whatsapp .box span {
	font-size: 13px;
}
.swal2-shown {
	z-index: 2024 !important;
}
</style>
